import jwtDecode from 'jwt-decode';
import ClusterCircle from '../assets/clusterCircle.svg';
import { LEAF_ICONS, PRELOADED_ICONS, SMB_ICONS } from '../constants/IconConstants';
import ALL_ROLES from '../constants/roles';

export const isFilled = (inputVar: any) => {
  return inputVar !== undefined && inputVar !== null && inputVar.toString().trim();
};

export const exists = (inputVar: any) => {
  return !(inputVar === undefined || inputVar === null || (typeof inputVar === 'string' && !inputVar.trim()));
};

export const isNumeric = (inputVar: any) => {
  return typeof inputVar === 'number';
};

export const getRegion = (): string => {
  try {
    const accestoken = localStorage.getItem('access_token') ?? '';
    const decoded: any = jwtDecode(accestoken);
    return decoded?.region ?? 'NO_REGION';
  } catch (error: any) {
    console.log(error);
    return 'NO_REGION';
  }
};

// Returns role in lowercase with spaces repalces with "_"
export const getRole = (): string => {
  try {
    const accestoken = localStorage.getItem('access_token') ?? '';
    const decoded: any = jwtDecode(accestoken);
    // TODO: standardize the roles in backend and frontend like below.
    // return decoded?.role.split(' ').join('_').toLowerCase() ?? "NO_ROLE"
    return decoded?.role ?? 'NO_ROLE';
  } catch (error: any) {
    console.log(error);
    return 'NO_ROLE';
  }
};

export const getUser = (): string => {
  try {
    const accestoken = localStorage.getItem('access_token') ?? '';
    const decoded: any = jwtDecode(accestoken);
    // TODO: standardize the roles in backend and frontend like below.
    // return decoded?.role.split(' ').join('_').toLowerCase() ?? "NO_ROLE"
    return decoded?.sub ?? 'NO_USER';
  } catch (error: any) {
    console.log(error);
    return 'NO_ROLE';
  }
};

export const generateWorkOrderId = (): string => {
  return Math.floor(1000 + Math.random() * 9000).toString();
};

export const getTechnology = (): string => {
  try {
    // const accestoken = localStorage.getItem("access_token") ?? ""
    // const decoded: any = jwtDecode(accestoken);
    // return decoded?.technology_type_name ?? "NO_TECH"
    return localStorage.getItem('technology_type') ?? 'NO_TECH';
  } catch (error: any) {
    console.log(error);
    return 'NO_TECH';
  }
};

export const getOrganisationId = (): number => {
  try {
    const accestoken = localStorage.getItem('access_token') ?? '';
    const decoded: any = jwtDecode(accestoken);
    return parseInt(decoded?.org_id ?? '0');
  } catch (error: any) {
    console.log(error);
    return 0;
  }
};

export const getAllowedRoles = () => {
  if (getOrganisationId() === 1) {
    return ALL_ROLES.filter((role) => role !== 'Technology Admin' && role !== 'Master Admin');
  }
  return ALL_ROLES;
};

// keeping default as sas for Charter. Shall Change after implementing Feature flags in future.
export const getProviderType = (): string => {
  try {
    const accestoken = localStorage.getItem('access_token') ?? '';
    const decoded: any = jwtDecode(accestoken);
    console.log(decoded, 'decodededx');
    return decoded?.provider_type ?? 'sas';
  } catch (error: any) {
    console.log(error);
    return 'sas';
  }
};

export const getClusterIcon = (): Promise<google.maps.Icon> => {
  return new Promise((resolve: any, reject: any) => {
    let icon: google.maps.Icon = {
      url: ClusterCircle,
      scaledSize: new window.google.maps.Size(30, 30),
      anchor: new window.google.maps.Point(15, 15),
      labelOrigin: new window.google.maps.Point(15, 15),
    };
    resolve(icon);
  });
};

{
  /**
   * returns the correct marker icon based on the zoom, status, and mounting type of the asset.
   * dots for zoom levels 0-14, and rotating leaves for zoom levels 15-22
   */
}
export const getMarkerIcon = (asset: any): Promise<google.maps.Icon> => {
  return new Promise((resolve: any, reject: any) => {
    rotateLeaves(asset).then((icon: any) => {
      resolve(icon);
    });
  });
};

const getMarker = (canvas: any, times: any, hasSectors: boolean = true) => {
  let url: string = canvas.toDataURL();
  return {
    url: url || '',
    scaledSize: new google.maps.Size(30 * times, 30 * times),
    anchor: new google.maps.Point(15 * times, 15 * times),
    labelOrigin: hasSectors ? new google.maps.Point(15 * times, 50 - 20 * (1 - times)) : new google.maps.Point(15 * times, 50),
  };
};

const imageOnLoad = (context: any, canvas: any, marker: any, resolve: any, mountingType: any, asset: any) => {
  // console.log('angle', asset);

  if (mountingType) {
    for (let index = 0; index < asset?.azimuth?.length; index++) {
      let angle = asset.azimuth[index];
      let sectorStatus: string = asset.status_sector[index];
      let leaf: any = LEAF_ICONS[sectorStatus];
      let image: HTMLImageElement = new Image();
      image.onload = () => {
        if (context) {
          context.save();
          context.translate(canvas.width / 2, canvas.height / 2);
          context.rotate((angle * Math.PI) / 180);
          context.drawImage(image, -image.width / 2, -image.height / 2);
          context.restore();
          // console.log('priint', angle, (angle * Math.PI) / 180);
        }
        if (index + 1 === asset.azimuth.length) {
          marker = getMarker(canvas, 2, +angle <= 90 || +angle >= 260 ? false : true);
          resolve(marker);
          // console.log('priint 2');
        }
      };
      image.src = leaf;
    }
  } else {
    let smbIcon: any = '';
    if (asset?.status === 'Preloaded') {
      smbIcon = {
        url: PRELOADED_ICONS[asset.status] || '',
        scaledSize: new google.maps.Size(30, 30),
        anchor: new google.maps.Point(15, 30),
        labelOrigin: new google.maps.Point(12, 45),
      };
      resolve(smbIcon);
    } else {
      smbIcon = SMB_ICONS[asset.status];
    }
    let image: HTMLImageElement = new Image();
    image.onload = () => {
      if (context) {
        context.save();
        context.translate(canvas.width / 2, canvas.height / 2);
        context.drawImage(image, -image.width / 2, -image.height / 2);
        context.restore();
      }
      marker = getMarker(canvas, 1);
      resolve(marker);
    };
    image.src = smbIcon;
  }
};

{
  /**
   * rotate the leaf based on the azimuth of the asset.
   * creates a canvas and draws the leaf on it, then returns icon for the marker.
   */
}
const rotateLeaves = (asset: any): Promise<google.maps.Icon> => {
  return new Promise((resolve: any, reject: any) => {
    let marker: google.maps.Icon = {
      url: '',
    };

    if (asset.directionality !== 'Directional') {
      const canvas = document.createElement('canvas');
      canvas.width = 100;
      canvas.height = 100;
      canvas.style.backgroundColor = 'transparent';
      let context = canvas.getContext('2d');
      imageOnLoad(context, canvas, marker, resolve, '', asset);
      if (!canvas) {
        reject(marker);
      }
    } else {
      const canvas = document.createElement('canvas');
      canvas.width = 170;
      canvas.height = 170;
      canvas.style.backgroundColor = 'transparent';
      let context = canvas.getContext('2d');
      imageOnLoad(context, canvas, marker, resolve, 'AERIAL-ROE', asset);
      if (!canvas) {
        reject(marker);
      }
    }
  });
};
export const getTechnologyDisplayValue: any = {
  cbrs_5g: '5G',
  wifi_6e: 'Wi-Fi',
  cpe_cbsd: 'CPE',
  cpe_wifi: 'CPE',
  '': 'Asset',
  '5g': '5G',
  tarana: 'Tarana',
};
export const getTechSearchValue: any = {
  cbrs_5g: '5G',
  wifi_6e: 'Wi-Fi',
  cpe_cbsd: 'CPE',
  cpe_wifi: 'CPE',
  '': 'Asset',
  '5g': '5G',
  tarana: 'Nodes',
};
const techOptions = [
  { value: 'cbrs_5g', label: '5G' },
  { value: 'wifi_6e', label: 'Wi-Fi' },
  { value: 'cpe_cbsd', label: 'CPE' },
  { value: 'cpe_wifi', label: 'CPE' },
  { value: 'tarana', label: 'Base Node' },
  { value: 'tarana_cpe', label: 'Remote Node' },
];
export const getTechType = () => {
  const techType = getTechnology();
  return techOptions.find((val) => val['value'] == techType)?.label;
};

export const legendTechDisplay = [
  { value: 'cbrs_5g', label: '5G Base Station' },
  { value: 'cpe_cbsd', label: '5G CPE' },
  { value: 'wifi_6e', label: 'Wi-Fi AP' },
  { value: 'cpe_wifi', label: 'Wi-Fi CPE' },
  { value: 'tarana', label: 'Tarana Base Node' },
  { value: 'tarana_cpe', label: 'Tarana Remote Node' },
];

export const getDeviceTitle: any = {
  wifi_6e: 'Wi-Fi AP',
  cbrs_5g: 'Base Station',
  cpe_cbsd: 'CPE',
  cpe_wifi: 'CPE',
  '': 'ASSET',
  tarana: 'Base Node',
  tarana_cpe: 'Remote Node',
};

export const shortLabel: any = {
  wifi_6e: 'Wi-Fi',
  cbrs_5g: 'Base Station',
  cpe_cbsd: 'CPE',
  cpe_wifi: 'CPE',
  '': 'ASSET',
  tarana: 'BN',
  tarana_cpe: 'RN',
};
type LatLngNew = { lat: number; lng: number };

/**
 * Precise un-rotation using EPSG:3857 projection.
 *
 * rotatedPolygon: points after rotation (array of {lat,lng})
 * angleDeg: rotation angle in degrees that was applied (use +ve if polygon was rotated clockwise)
 * anchor: optional rotation anchor in lat/lng. If omitted, centroid (in projected meters) is used.
 * returnUnrotated: if true, function includes the unrotated points in the returned object.
 */
export function getUnrotatedBoundsPrecise(
  rotatedPolygon: LatLngNew[],
  angleDeg: number,
  anchor: LatLngNew | 'center' = 'center',
  returnUnrotated = false
): {
  north: number;
  south: number;
  east: number;
  west: number;
  unrotated?: LatLngNew[];
} {
  if (!rotatedPolygon || rotatedPolygon.length < 1) {
    throw new Error('rotatedPolygon must have at least 1 point');
  }

  const R = 6378137; // Web Mercator Earth radius (meters)
  const deg2rad = (d: number) => (d * Math.PI) / 180;
  const rad2deg = (r: number) => (r * 180) / Math.PI;

  // Project lon/lat to EPSG:3857 (x,y in meters)
  const project = (lng: number, lat: number) => {
    const x = R * deg2rad(lng);
    const y = R * Math.log(Math.tan(Math.PI / 4 + deg2rad(lat) / 2));
    return { x, y };
  };

  // Inverse project EPSG:3857 -> lon/lat
  const unproject = (x: number, y: number) => {
    const lng = rad2deg(x / R);
    const lat = rad2deg(2 * Math.atan(Math.exp(y / R)) - Math.PI / 2);
    return { lat, lng };
  };

  // compute anchor in projected coords
  let cx: number, cy: number;
  if (anchor !== 'center') {
    const p = project(anchor.lng, anchor.lat);
    cx = p.x;
    cy = p.y;
  } else {
    // centroid in projected coordinates (more accurate than averaging lat/lng)
    const proj = rotatedPolygon.map((p) => project(p.lng, p.lat));
    cx = proj.reduce((s, p) => s + p.x, 0) / proj.length;
    cy = proj.reduce((s, p) => s + p.y, 0) / proj.length;
  }

  const a = -angleDeg * (Math.PI / 180); // anti-rotate angle in radians
  const cosA = Math.cos(a);
  const sinA = Math.sin(a);

  const unrotated: LatLngNew[] = rotatedPolygon.map((p) => {
    const { x, y } = project(p.lng, p.lat);
    const dx = x - cx;
    const dy = y - cy;
    const rx = dx * cosA - dy * sinA;
    const ry = dx * sinA + dy * cosA;
    const x2 = rx + cx;
    const y2 = ry + cy;
    return unproject(x2, y2);
  });

  const lats = unrotated.map((p) => p.lat);
  const lngs = unrotated.map((p) => p.lng);

  const north = Math.max(...lats);
  const south = Math.min(...lats);
  const east = Math.max(...lngs);
  const west = Math.min(...lngs);

  return returnUnrotated ? { north, south, east, west, unrotated } : { north, south, east, west };
}

export function isPointInPolygon(point: any, polygon: any[]): boolean {
  const { lat, lng } = point;

  let inside = false;

  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i].lng;
    const yi = polygon[i].lat;
    const xj = polygon[j].lng;
    const yj = polygon[j].lat;

    // Check if the point is within the polygon edges
    const intersect = yi > lat !== yj > lat && lng < ((xj - xi) * (lat - yi)) / (yj - yi) + xi;

    if (intersect) inside = !inside;
  }

  return inside;
}

export const generateRandomAlphanumeric = (requiredLength: number = 10): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  let result = '';
  const charactersLength = characters.length;

  for (let i = 0; i < requiredLength; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }

  return result;
};

export function getLineCenter(pointA: { lat: number; lng: number }, pointB: { lat: number; lng: number }) {
  return {
    lat: (pointA.lat + pointB.lat) / 2,
    lng: (pointA.lng + pointB.lng) / 2,
  };
}

export const legendRfData = [
  {
    l: '-20dBm',
    r: 255,
    g: 19,
    b: 0,
  },
  {
    l: '-24dBm',
    r: 255,
    g: 61,
    b: 0,
  },
  {
    l: '-28dBm',
    r: 255,
    g: 102,
    b: 0,
  },
  {
    l: '-32dBm',
    r: 255,
    g: 144,
    b: 0,
  },
  {
    l: '-36dBm',
    r: 255,
    g: 185,
    b: 0,
  },
  {
    l: '-40dBm',
    r: 255,
    g: 227,
    b: 0,
  },
  {
    l: '-44dBm',
    r: 242,
    g: 255,
    b: 0,
  },
  {
    l: '-48dBm',
    r: 200,
    g: 255,
    b: 0,
  },
  {
    l: '-52dBm',
    r: 159,
    g: 255,
    b: 0,
  },
  {
    l: '-56dBm',
    r: 117,
    g: 255,
    b: 0,
  },
  {
    l: '-60dBm',
    r: 76,
    g: 255,
    b: 0,
  },
  {
    l: '-64dBm',
    r: 34,
    g: 255,
    b: 0,
  },
  {
    l: '-68dBm',
    r: 0,
    g: 255,
    b: 7,
  },
  {
    l: '-72dBm',
    r: 0,
    g: 255,
    b: 49,
  },
  {
    l: '-76dBm',
    r: 0,
    g: 255,
    b: 90,
  },
  {
    l: '-80dBm',
    r: 0,
    g: 255,
    b: 132,
  },
  {
    l: '-84dBm',
    r: 0,
    g: 255,
    b: 173,
  },
  {
    l: '-88dBm',
    r: 0,
    g: 255,
    b: 215,
  },
  {
    l: '-92dBm',
    r: 0,
    g: 254,
    b: 255,
  },
  {
    l: '-96dBm',
    r: 0,
    g: 212,
    b: 255,
  },
  {
    l: '-100dBm',
    r: 0,
    g: 171,
    b: 255,
  },
  {
    l: '-104dBm',
    r: 0,
    g: 129,
    b: 255,
  },
  {
    l: '-108dBm',
    r: 0,
    g: 88,
    b: 255,
  },
  {
    l: '-112dBm',
    r: 0,
    g: 46,
    b: 255,
  },
];

// returns color code based on signal strength value which falls between -20 to -112 dBm correspondingly to the legendRfData
export const getSignalStrengthColor = (signalStrength: number): string => {
  if (signalStrength >= -20) {
    return `rgb(${legendRfData[0].r}, ${legendRfData[0].g}, ${legendRfData[0].b})`;
  }
  if (signalStrength <= -112) {
    return `rgb(${legendRfData[legendRfData.length - 1].r}, ${legendRfData[legendRfData.length - 1].g}, ${legendRfData[legendRfData.length - 1].b})`;
  }

  for (let i = 0; i < legendRfData.length - 1; i++) {
    const current = legendRfData[i];
    const next = legendRfData[i + 1];

    if (signalStrength <= parseInt(current.l) && signalStrength >= parseInt(next.l)) {
      // Linear interpolation between current and next
      const ratio = (signalStrength - parseInt(next.l)) / (parseInt(current.l) - parseInt(next.l));
      const r = Math.round(current.r + ratio * (next.r - current.r));
      const g = Math.round(current.g + ratio * (next.g - current.g));
      const b = Math.round(current.b + ratio * (next.b - current.b));

      return `rgb(${r}, ${g}, ${b})`;
    }
  }

  // Default color (should not reach here)
  return 'rgb(0, 0, 0)';
};
